
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestrounduplawyers/contact-us",
      function () {
        return require("private-next-pages/bestrounduplawyers/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestrounduplawyers/contact-us"])
      });
    }
  